import React, { useState, useEffect } from 'react';
import QuoteAllModes from "./QuoteAllModes";
import { depositModesForPlanTypeUntranslated } from "../Utils/PlanUtils";
import {jsPDF} from "jspdf";

//This component generates and displays a PDF containing one page for each deposit mode
//The way this works is this component maintains an array of images, one for each page of the PDF
//Each image is generated by each subcomponent (GroupQuote, AchieversQuote, SelfInitiatedQuote) of the QuoteAllModes component, which is rendered off-screen
//When each component is finished rendering, it calls back the parent component with the generated image.
//Once all images are generated, they are combined into a single PDF
//The PDF is then displayed in an iframe
//A loading screen is displayed while the PDF is being generated, which tracks the number of pages that have been
//generated
const QuotePDFViewer = ({ state }) => {
    const [quoteImage, setQuoteImage] = useState('');
    const [blobURL, setBlobURL] = useState('');
    const [totalQuotePages, setTotalQuotePages] = useState(0);
    const [quotePageImages, setQuotePageImages] = useState([]);
    const [pdfDoc, setPdfDoc] = useState(null);
    const [completedPageCount, setCompletedPageCount] = useState(0);

    useEffect(() => {
        const length = depositModesForPlanTypeUntranslated(state.plan.planTypeID).length + 1;
        setTotalQuotePages(length);
        setQuotePageImages(new Array(length).fill(null));

    }, [state.plan.planTypeID]);

    //Once all quote page images are provided, we can generate the full PDF
    useEffect(() => {
        if (blobURL) { return; }
        if (quotePageImages.length === 0 || quotePageImages.includes(null)) { return; }

        const doc = new jsPDF();
        quotePageImages.forEach((image, index) => {
            if (image) {
                //200 x 297 mm
                //Draw each page into the PDF with the correct aspect ratio so it doesn't look stretched, while still
                // fitting into 200 x 297
                let width = doc.getImageProperties(image).width;
                let height = doc.getImageProperties(image).height;
                const scaleFactor = 200 / width;

                doc.addImage(image, 'PNG', 5, (297 - (height * scaleFactor)) / 2.0, width * scaleFactor, height * scaleFactor, '', 'FAST');
                if (index < totalQuotePages - 1) {
                    doc.addPage();
                }
            }
        });

        setPdfDoc(doc);
        // Create a blob URL for the PDF
        setBlobURL(URL.createObjectURL(doc.output("blob")));

    }, [quotePageImages]);

    return (
        <div>
            {!blobURL &&
                <div className={'loading-screen'}>
                    <div>
                        <div>
                            Generating PDF...
                        </div>
                        <div>
                            Page {completedPageCount} of {totalQuotePages}
                        </div>
                        <div>
                            <img  src={'/images/pencil.png'} alt={''} className={'wiggling'}/>
                        </div>
                    </div>
                </div>
            }
            {blobURL &&
                <iframe title={'Quote Review'} src={blobURL} />
            }
            {!blobURL &&
                <div style={{position: 'absolute', left: '-1000px'}}>
                    <QuoteAllModes
                        state={state}
                        showAllSimultaneously={true}
                        setCompletedQuoteImages={setQuotePageImages}
                        setCompletedPageCount={setCompletedPageCount}
                        fullScale={true}
                    />
                </div>
            }
        </div>
    )
}

export default QuotePDFViewer;